import { render, staticRenderFns } from "./LSelectTree.vue?vue&type=template&id=47df6d50&scoped=true"
import script from "./LSelectTree.vue?vue&type=script&lang=js"
export * from "./LSelectTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47df6d50",
  null
  
)

export default component.exports